<script setup>
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ActionCenter from 'dashboard/routes/dashboard/conversation/contact/ActionCenter.vue';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
  contact: {
    type: Object,
    default: () => ({}),
  },
  currentChat: {
    type: Object,
    default: () => ({}),
  },
  channelType: {
    type: String,
    default: '',
  },
  activeBookingCount: {
    type: Number,
    default: 0,
  },
  activeBookingIds: {
    type: String,
    default: '',
  },
  activeBookingSummaryLines: {
    type: Array,
    default: () => [],
  },
});

const dialogRef = ref(null);

const open = () => {
  dialogRef.value?.open();
};

const close = () => {
  dialogRef.value?.close();
};

defineExpose({
  open,
  close,
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="3xl"
    position="top"
    :title="$t('CONTACT_PANEL.ACTION_CENTER.MODAL.TITLE')"
    :description="$t('CONTACT_PANEL.ACTION_CENTER.MODAL.DESCRIPTION')"
    :cancel-button-label="$t('CONTACT_PANEL.ACTION_CENTER.MODAL.CLOSE')"
    :show-confirm-button="false"
    scroll-content
  >
    <div class="min-h-0 ltr:-mr-2 ltr:pr-2 rtl:-ml-2 rtl:pl-2">
      <ActionCenter
        :conversation-id="conversationId"
        :contact="contact"
        :current-chat="currentChat"
        :channel-type="channelType"
        :active-booking-count="activeBookingCount"
        :active-booking-ids="activeBookingIds"
        :active-booking-summary-lines="activeBookingSummaryLines"
      />
    </div>
  </Dialog>
</template>
